const language = {
    english: 'English',
    german: 'Deutsch',
    selectLanguage: 'Select Language',
  } as const;

export default language;
